
export const absenteeism = {
	perYear: (sales, numberOfDaysAbsent) => {
		const value = parseFloat(sales);
		const daysAbsent = parseFloat(numberOfDaysAbsent);
		if (isNaN(value) || isNaN(daysAbsent)) return;
		return ((value/233) * daysAbsent).toFixed(2);
	},
	perDay: (sales) => {
		const value = parseFloat(sales);
		if (isNaN(value)) return;
		return (value/233).toFixed(2);
	},
	annualCost: (costPerYear, numberOfEmployees) => {
		const valueOfCostPerYear = parseFloat(costPerYear);
		const valueOfNumberOfEmployees = parseInt(numberOfEmployees, 10);
		if (isNaN(valueOfCostPerYear) || isNaN(valueOfNumberOfEmployees)) return;
		return (valueOfCostPerYear * valueOfNumberOfEmployees).toFixed(2);
	},
	annualSaving: (annualCost, reductionPCT) => {
		const valueOfAnnualCost = parseFloat(annualCost);
		const valueOfReductionPCT = parseInt(reductionPCT, 10);
		if (isNaN(valueOfAnnualCost) || isNaN(valueOfReductionPCT)) return;
		return (valueOfAnnualCost * (valueOfReductionPCT / 100)).toFixed(2);
	}
};



// WEBPACK FOOTER //
// ./src/services/Calculate/index.js